import { useRouter } from "next/router"
import React from "react"

import { useTranslation } from "@bounce/i18n"
import { Link, Tab, Tabs } from "@bounce/web-components"

export const Topics = () => {
  const { t } = useTranslation("marketing-generic")
  const router = useRouter()
  const query = router.query.q?.toString() ?? ""

  const topics = [
    {
      name: t("cmp.blogNav.all", "All"),
      query: "",
    },
    {
      name: t("cmp.blogNav.travel", "Travel"),
      query: "travel",
    },
    {
      name: t("cmp.blogNav.leisure", "Leisure"),
      query: "leisure",
    },
    {
      name: t("cmp.blogNav.adventure", "Adventure"),
      query: "adventure",
    },
    {
      name: t("cmp.blogNav.vacation", "Vacation"),
      query: "vacation",
    },
  ]

  return (
    <Tabs className="hidden md:flex">
      {topics.map(topic => (
        <Tab
          as={Link}
          href={`/blog?q=${topic.query}`}
          shallow
          active={query.toLowerCase() === topic.query.toLowerCase()}
          label={topic.name}
          key={topic.name}
        />
      ))}
    </Tabs>
  )
}
